import axios from "axios";
import { MDBInput, MDBModal, MDBModalBody, MDBModalHeader } from "mdbreact";
import React from "react";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import image from "../../assets/waiver.png";
import { admission } from "../ADMISSION";

function WaiverForm() {
  const [reason, setReason] = useState();
  const [names, setName] = useState();
  const [email, setEmail] = useState();
  const [stdId, setStdID] = useState();
  const [citizen, setCitizen] = useState();
  const [major, setMajor] = useState();
  const [faculty, setFaculy] = useState();
  const [fill, setFill] = useState(false);
  const [showmodal, setShowModal] = useState(false);

  const [filedoc, setFiledoc] = useState(null);
  const [Filedoc_name, setFiledoc_name] = useState(null);
  const [filedocument, setFiledocument] = useState(null);
  const [fileNamePre, setFileNamePre] = useState("");
  const [newFileName, setNewFileName] = useState("");
  const [typeFile, setTypeFile] = useState();
  useEffect(() => {
    axios
      .get(admission + "/student/loadpresent/" + localStorage.getItem("ID_LOGIN"))
      .then((res) => {
        console.log(res.data[0]);
        const data = res.data[0];
        setName(data.FULLNAME + data.FRISTNAME_LOGIN + " " + data.LASTNAME_LOGIN);
        setStdID(data.REGISTER_ID);
        setCitizen(data.CITIZENT_LOGIN);
        setMajor(data.MAJOR_NAME);
        setFaculy(data.faculty_name);
      });
    axios
      .get(admission + "/dashboard_profile/profile/" + localStorage.getItem("ID_LOGIN"))
      .then((res) => {
        const data = res.data[0];
        setEmail(data.EMAIL_LOGIN);
      });
    return () => {};
  });
  const [images, setImages] = useState([]);
  const [file, setFile] = useState();
  const [typename, setTypeName] = useState("");
  const handleChange = (event) => {
    event.preventDefault();
    setImages([...event.target.files]);
    setFile(event.target.files[0]);
    console.log(event.target.files[0]);
    var files = event.target.files[0];
    var type = files.type.split("/");
    var typee = files.type;
    setTypeName("." + type[1]);
    setTypeFile(type[1]);
    console.log(typename);
    if (type[1] === "pdf") {
      setFileNamePre(files.name);
      setFill(true);
      setFiledocument(event.target.files[0]);
      setNewFileName(localStorage.getItem("ID_LOGIN") + "waiver");
    } else if (typee === "image/png" || typee === "image/jpeg" || typee === "image/jpg") {
      setFileNamePre(files.name);
      setFill(true);
      setFiledocument(event.target.files[0]);
      setNewFileName(localStorage.getItem("ID_LOGIN") + "waiver");
    } else {
      Swal.fire({
        icon: "error",
        title: "กรุณาเลือกไฟล์ PDF หรือ รูปภาพ png jpeg และ jpg",
      });
      setFileNamePre("");
      setFill(false);
    }
  };
  const onSubmit = (e) => {
    // e.preventDefault();
    Swal.fire({
      icon: "info",
      title: "ต้องการขอสละสิทธิ์การเข้าศึกษา ?",
      confirmButtonColor: "#29bf12",
      confirmButtonText: "ยืนยัน",
      cancelButtonColor: "#e63946",
      cancelButtonText: "ยกเลิก",
      showCancelButton: true,
    }).then((res) => {
      if (res.isConfirmed === true) {
        const formData = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
        formData.append("UserID", localStorage.getItem("ID_LOGIN"));
        formData.append("REGISTER_ID", stdId);
        formData.append("file", filedocument);
        axios
          .post("https://admission.kpru.ac.th/admission2017/student_waiver/fileUpload", formData)
          .then((res) => {
            console.log(res.data);
            // if (res.data === "error") {
            //   Swal.fire({
            //     icon: "error",
            //     text: "กรุณาเลือกไฟล์นามสกุล pdf png jpeg และ jpg ในการอัพโหลด",
            //   });
            // } else {
            const pathfile = res.data;
            console.log(res.data);
            axios
              .post("https://admission.kpru.ac.th/admission2017/student_waiver/savewaiver", {
                REGISTER_IDX: stdId,
                REASON: reason,
                FILE_UPLOAD: pathfile,
              })
              .then((res1) => {
                if (res1.data === "200") {
                  Swal.fire({
                    icon: "success",
                    text: "คำขอเสร็จสิ้น กรุณารอเจ้าหน้าที่อนุมัติ",
                    timer: 3000,
                    // timerProgressBar: true,
                    // showConfirmButton: false,
                  }).then((ress) => {
                    window.location.pathname = "/";
                  });
                }
              });
            // }
          });
      }
    });
  };
  return (
    <div className="container mt-2 p-2 mb-5">
      <form>
        <div
          className="bg-danger h-50 d-flex mb-2 rounded justify-content-center align-items-center text-white "
          style={{ minHeight: "100px", fontSize: "1.6rem", fontWeight: "600" }}
        >
          ฟอร์มขอสละสิทธิ์การเข้าศึกษา
        </div>
        <div className="d-flex flex-column">
          <MDBInput label="หัวข้อ" value="ขอสละสิทธิ์การเข้าศึกษา" background disabled />
          <MDBInput
            label="เหตุผลที่ขอสละสิทธิ์ *"
            hint="กรุณากรอกเหตุผลการสละสิทธิ์"
            required
            type="textarea"
            value={reason || ""}
            onChange={(e) => setReason(e.target.value)}
          />
          <MDBInput label="ชื่อ-สกุล ผู้ขอสละสิทธิ์" background value={names} disabled />
          <MDBInput label="E-mail ผู้ขอสละสิทธิ์" background value={email} disabled />
          <MDBInput label="รหัสนักศึกษา" background value={stdId} disabled />
          <MDBInput label="เลขบัตรประจำตัวประชาชน" background value={citizen} disabled />
          <MDBInput label="สาขาวิชาที่ได้รับคัดเลือก" background value={major} disabled />
          <MDBInput label="คณะที่ได้รับคัดเลือก" background value={faculty} disabled />
          <div className="d-flex flex-column flex-md-row">
            {fileNamePre ? (
              <>
                <span style={{ fontWeight: "600" }}>ไฟล์ที่เลือก :</span> {fileNamePre}
              </>
            ) : (
              <>
                <div className="d-flex row justify-content-center">
                  <div className="col-12 d-flex justify-content-center ">
                    <img src={image} alt="" width={100} />
                    <div
                      onClick={(e) => {
                        setShowModal(true);
                      }}
                      className="btn btn-sm  w-100 tua-yang  col"
                      style={{ height: "40px" }}
                    >
                      คลิกดูตัวอย่างเอกสาร
                    </div>
                  </div>
                </div>
              </>
            )}
            <div className="col ">
              <label for="filedoc" className="custom-file-upload btn-block text-center ">
                <i className="fa fa-cloud-upload"></i> คลิกอัพโหลดหลักฐานสำเนาบัตรประจำตัวประชาชน
                *.pdf, รูปภาพ
              </label>
              <input
                type="file"
                className="form-control col-sm-12"
                id="filedoc"
                name="filedoc"
                accept="application/pdf,image/png, image/jpg, image/jpeg"
                onChange={handleChange}
                required
              />
            </div>
          </div>
        </div>
        {fill === true && reason ? (
          <>
            <div
              onClick={onSubmit}
              className="btn btn-md btn-success w-100  "
              style={{ fontSize: "1.2rem" }}
            >
              ส่งข้อมูลการขอสละสิทธิ์
            </div>
          </>
        ) : (
          <>
            <div
              onClick={onSubmit}
              className="btn btn-md btn-success w-100 disabled"
              style={{ fontSize: "1.2rem" }}
            >
              ส่งข้อมูลการขอสละสิทธิ์
            </div>
            <span className="text-danger">* กรุณากรอกข้อมูลให้ครบถ้วน</span>
          </>
        )}
      </form>

      <MDBModal isOpen={showmodal} toggle={() => setShowModal(!showmodal)} top>
        <MDBModalHeader>รูปตัวอย่างสำเนาปัตรประชาชนที่ต้องอัพโหลด</MDBModalHeader>
        <MDBModalBody>
          <img src={image} alt="รูปตัวอย่างเอกสารที่ต้องอัพโหลด" width="100%" />
        </MDBModalBody>
      </MDBModal>
    </div>
  );
}

export default WaiverForm;
